import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { platformChatService } from '../../../services/PlatformChatService';
import { chatQueryKeys } from '../chatQueryKeys';

export function usePlatformChatLinkedKnowledgeBasesQuery(sessionId?: string) {
  const { user } = useAuth();
  const resolvedSessionId = sessionId ?? '';
  const isEnabled =
    Boolean(user) && typeof sessionId === 'string' && sessionId.length > 0;

  return useQuery({
    queryKey: chatQueryKeys.linkedKnowledgeBases(resolvedSessionId),
    enabled: isEnabled,
    queryFn: () =>
      platformChatService.listLinkedKnowledgeBases(resolvedSessionId),
  });
}
